module.exports = __webpack_public_path__ + "static/media/team-2.d33e7e60.png";